var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moving-image"},[(_vm.src && _vm.visible)?_c('video',{attrs:{"loop":"","muted":"","playsinline":"","autoplay":""},domProps:{"muted":true}},[_c('source',{attrs:{"type":"video/mp4","src":_vm.src}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }